import { combineReducers } from 'redux';
import boardReducer from './board';
import roomReducer from './room';
import handReducer from './hand';
import selectedReducer from './selected';
import { reducer as toastrReducer } from 'react-redux-toastr';
import playerReducer from './player';
import availableFieldReducer from './availableField';
import combatReducer from './combat';
import killedCharReducer from './killedChars';
import winnerReducer from './winner';

const allReducers = combineReducers({
    board: boardReducer,
    room: roomReducer,
    hand: handReducer,
    selected: selectedReducer,
    toastr: toastrReducer,
    player: playerReducer,
    availableFields: availableFieldReducer,
    combat: combatReducer,
    kills: killedCharReducer,
    winner: winnerReducer,
});

export default allReducers;
